import { render, staticRenderFns } from "./AddPermission.vue?vue&type=template&id=3a5298b8&scoped=true&"
import script from "./AddPermission.vue?vue&type=script&lang=js&"
export * from "./AddPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5298b8",
  null
  
)

export default component.exports